import { useLang, LangToggle } from "../lib/i18n";
import { LogoMark } from "../lib/brand";

export default function Login() {
  const { t } = useLang();

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex flex-col justify-between bg-brand-dark p-12 text-white">
        <div className="flex items-center gap-3">
          <LogoMark className="w-10 h-10" />
          <span className="font-display font-bold text-lg">KOPERA</span>
        </div>
        <div>
          <h2 className="font-display text-4xl font-extrabold leading-tight text-balance">
            Satu Platform Untuk Mengurus Ahli, Saham, Yuran, Kewangan, AGM & AI Koperasi.
          </h2>
          <p className="mt-4 text-emerald-100/70 max-w-md">
            Multi-tenant • White label • Jejak audit • Maker-checker • Pembantu AI
          </p>
        </div>
        <div className="text-xs text-emerald-100/50 uppercase tracking-[0.2em]">Software for Cooperatives</div>
      </div>
      <div className="flex flex-col items-center justify-center p-8 bg-background">
        <div className="absolute top-6 right-6"><LangToggle /></div>
        <div className="w-full max-w-sm" data-testid="login-panel">
          <div className="lg:hidden flex items-center gap-3 mb-8 justify-center">
            <LogoMark className="w-10 h-10" />
            <span className="font-display font-bold text-lg text-brand-dark">KOPERA</span>
          </div>
          <h1 className="font-display text-2xl font-bold text-brand-dark text-center">{t("login.title")}</h1>
          <p className="text-sm text-muted-foreground text-center mt-2 mb-8">{t("login.sub")}</p>
          <button
            data-testid="google-login-btn"
            onClick={handleGoogle}
            className="w-full flex items-center justify-center gap-3 bg-white border border-brand-deep/20 rounded-xl px-4 py-3.5 font-medium text-brand-dark hover:shadow-md hover:border-brand-deep/40 transition-all"
          >
            <svg className="w-5 h-5" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
            </svg>
            {t("login.google")}
          </button>
          <p className="text-[11px] text-muted-foreground text-center mt-6">
            Pentadbir Platform • Pentadbir Koperasi • Portal Ahli
          </p>
        </div>
      </div>
    </div>
  );
}
